import * as helpers from './helpers'

const defaultListReducerForNitratiVirszemesStacijas = helpers.createListReducer({listViewName: 'nitrati_virszemes_stacijas', actionsName: 'nitratiVirszemesActions'})
const defaultEditReducerForNitratiVirszemesStacijas = helpers.createEditReducer({editViewName: 'nitrati_virszemes_stacijas', actionsName: 'nitratiVirszemesActions'})

export const nitratiVirszemes = (state = helpers.listEditGetInitialState(), {type, payload, reqId}) => {
    //overwrite or add custom actions catches here

    const stateAfterList = defaultListReducerForNitratiVirszemesStacijas({state, type, payload, reqId})
    return defaultEditReducerForNitratiVirszemesStacijas({state : stateAfterList, type, payload, reqId})
}


const defaultListReducerForNitratiPazemesStacijas = helpers.createListReducer({listViewName: 'nitrati_pazemes_stacijas', actionsName: 'nitratiPazemesActions'})
const defaultEditReducerForNitratiPazemesStacijas = helpers.createEditReducer({editViewName: 'nitrati_pazemes_stacijas', actionsName: 'nitratiPazemesActions'})

export const nitratiPazemes = (state = helpers.listEditGetInitialState(), {type, payload, reqId}) => {
    //overwrite or add custom actions catches here

    const stateAfterList = defaultListReducerForNitratiPazemesStacijas({state, type, payload, reqId})
    return defaultEditReducerForNitratiPazemesStacijas({state : stateAfterList, type, payload, reqId})
}


const defaultListReducerForRobezvertibas = helpers.createListReducer({listViewName: 'eitrofikacijas_robezvertibas', actionsName: 'eitrofikacijasRobezvertibas'})
const defaultEditReducerForRobezvertibas = helpers.createEditReducer({editViewName: 'eitrofikacijas_robezvertibas', actionsName: 'eitrofikacijasRobezvertibas'})
export const eitrofikacijasRobezvertibas = (state = helpers.listEditGetInitialState(), {type, payload, reqId}) => {
  //overwrite or add custom actions catches here

  const stateAfterList = defaultListReducerForRobezvertibas({state, type, payload, reqId})
  return defaultEditReducerForRobezvertibas({state: stateAfterList, type, payload, reqId})
}
